import React from 'react';
import classes from './InputWithError.module.css';

const InputWithError = ({ 
  label, 
  value, 
  onChange, 
  onKeyPress,
  error,
  placeholder = '',
  buttonText,
  onButtonClick,
  buttonDisabled = false
}) => {
  return (
    <div className={classes.inputSection}>
      {label && <label className={classes.label}>{label}</label>}
      <div className={classes.inputRow}>
        <input
          type="text"
          className={classes.input}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          onKeyPress={onKeyPress}
        />
        {buttonText && (
          <button 
            onClick={onButtonClick} 
            className={classes.button}
            disabled={buttonDisabled}
          >
            {buttonText}
          </button>
        )}
      </div>
      {error && (
        <div className={classes.errorMessage}>{error}</div>
      )}
    </div>
  );
};

export default InputWithError;

